export class EmailRendererTest {
    public html: string;
    public id: string;
    public subject: string;

    constructor(emailRendererTest?: EmailRendererTest) {
        this.html = emailRendererTest && emailRendererTest.html || null;
        this.id = emailRendererTest && emailRendererTest.id || null;
        this.subject = emailRendererTest && emailRendererTest.subject || null;
    }
}
